import apiHandler from '../ApiHandler';

export interface DocumentGenerationProgressResponse {
  tasks?: {
    task_type: string;
    task_name: string;
    status: 'PENDING' | 'IN_PROGRESS' | 'COMPLETED' | 'FAILED';
    progress_percentage?: number;
    current_step?: string;
    execution_time?: number;
    started_at?: string | number;
    finished_at?: string | number;
  }[];
  overall_percentage?: number;
  estimated_time_remaining?: number;
}

export const getDocumentGenerationProgress = async (
  documentId: string | number
): Promise<DocumentGenerationProgressResponse> => {
  return apiHandler.get<DocumentGenerationProgressResponse>(
    `/document-instances/${documentId}/progress/`
  ) as Promise<DocumentGenerationProgressResponse>;
};

export const uploadDocumentInstanceFieldFile = (
  data: FormData,
  callback: (response: any) => void,
  errorCallback?: (error: any) => void
) => {
  apiHandler
    .post(`/document-instance-custom-field-files/upload-files/`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      callback(response as any);
    })
    .catch((error) => {
      if (errorCallback) {
        errorCallback(error);
      }
    });
};

export const deleteDocumentInstanceFieldFile = (
  id: string | number,
  callback: (response: any) => void,
  errorCallback?: (error: any) => void
) => {
  apiHandler
    .delete(`/document-instance-custom-field-files/${id}/`)
    .then((response) => {
      callback(response as any);
    })
    .catch((error) => {
      if (errorCallback) {
        errorCallback(error);
      }
    });
};

export const uploadDocumentInstanceFieldImage = (
  data: FormData,
  callback: (response: any) => void,
  errorCallback?: (error: any) => void
) => {
  apiHandler
    .post(`/document-instance-custom-field-images/upload-images/`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      callback(response as any);
    })
    .catch((error) => {
      if (errorCallback) {
        errorCallback(error);
      }
    });
};

export const deleteDocumentInstanceFieldImage = (
  id: string | number,
  callback: (response: any) => void,
  errorCallback?: (error: any) => void
) => {
  apiHandler
    .delete(`/document-instance-custom-field-images/${id}/`)
    .then((response) => {
      callback(response as any);
    })
    .catch((error) => {
      if (errorCallback) {
        errorCallback(error);
      }
    });
};

export const uploadDocumentInstanceFieldAudio = (
  data: FormData,
  callback: (response: any) => void,
  errorCallback?: (error: any) => void
) => {
  apiHandler
    .post(
      `/document-instance-custom-field-audio-files/upload-audio-files/`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    )
    .then((response) => {
      callback(response as any);
    })
    .catch((error) => {
      if (errorCallback) {
        errorCallback(error);
      }
    });
};

export const deleteDocumentInstanceFieldAudio = (
  id: string | number,
  callback: (response: any) => void,
  errorCallback?: (error: any) => void
) => {
  apiHandler
    .delete(`/document-instance-custom-field-audio-files/${id}/`)
    .then((response) => {
      callback(response as any);
    })
    .catch((error) => {
      if (errorCallback) {
        errorCallback(error);
      }
    });
};

export const updateUserDocument = async (
  id: number | string,
  filename: any,
  callback: (response: any) => void
) => {
  apiHandler.patch(`/document-instances/${id}/`, filename).then((response) => {
    callback(response as any);
  });
};

export const uploadDocumentInstanceVersionFile = (
  data: FormData,
  callback: (response: any) => void,
  errorCallback?: (error: any) => void
) => {
  apiHandler
    .post(`/document-instance-version-files/upload-files/`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      callback(response as any);
    })
    .catch((error) => {
      if (errorCallback) {
        errorCallback(error);
      }
    });
};

export const deleteDocumentInstanceVersionFile = (
  id: string | number,
  callback: (response: any) => void,
  errorCallback?: (error: any) => void
) => {
  apiHandler
    .delete(`/document-instance-version-files/${id}/`)
    .then((response) => {
      callback(response as any);
    })
    .catch((error) => {
      if (errorCallback) {
        errorCallback(error);
      }
    });
};
